type NavigationHandler = (url: string) => void;
let handler: NavigationHandler | null = null;

export function registerLoginNavigationHandler(fn: NavigationHandler): void {
  handler = fn;
}

export function unregisterLoginNavigationHandler(): void {
  handler = null;
}

/**
 * 尝试通过 SPA router 导航到登录页。
 * @returns true 如果 handler 已注册并执行成功，false 需要 fallback 到 location.replace
 */
export function navigateToLoginViaSPA(url: string): boolean {
  if (!handler) {
    return false;
  }
  handler(url);
  return true;
}
